var map = {
	"./DINplus_large.png": 1882,
	"./DINplus_medium.png": 1883,
	"./DINplus_small.png": 1884,
	"./ENplus_large.png": 1885,
	"./ENplus_medium.png": 1886,
	"./ENplus_small.png": 1887,
	"./bundeslaender-test.svg": 1888,
	"./dinplus.png": 1114,
	"./dinplus_enplus.png": 1285,
	"./dinplus_iso.png": 1286,
	"./enplus.png": 1113,
	"./germany-filled-with-pellets.png": 1246,
	"./heizen-mit-holzpellets.webp": 1253,
	"./im-vergleich.webp": 1247,
	"./pellets-bigbag-mobile.png": 1889,
	"./pellets-bigbag.png": 1287,
	"./pellets-bigbag.webp": 1250,
	"./pellets-home-big.png": 1251,
	"./pellets-home-small.png": 1252,
	"./pellets-mobile.webp": 1890,
	"./pellets-sackware-mobile.png": 1891,
	"./pellets-sackware.png": 1288,
	"./pellets-sackware.webp": 1249,
	"./pellets-silowagen-mobile.png": 1892,
	"./pellets-silowagen.png": 1289,
	"./pellets-silowagen.webp": 1248,
	"./pellets.webp": 1893,
	"./sack-pellets.webp": 1894
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1430;